import './App.css';
import CreateLabels from './components/createLabels/createLabels';

import { AuthProvider, UserManager } from 'oidc-react';



import { SnackbarProvider } from './components/snackbar';
import { useState } from 'react';
import {BrowserRouter as Router, Route, Routes} from 'react-router-dom';
import Home from './components/home/Home';
import Orders from './components/orders/Orders';
import OrderDetail from './components/order/orderDetail';
// import ArticleDetail from './components/article/ArticleDetail';

import "./i18n"; // Import i18n configuration
import SalesOrders from './components/orders/SalesOrders';
import SalesWrapperDetail from './components/salesOrder/salesWrapperDetail';
import SalesWrapDetail from './components/salesOrder/salesWrapDetail';
import { WarehouseModule } from './modules/warehouse';


function App() {

    
    const [userManager] = useState(new UserManager({ 
        redirect_uri: process.env.REACT_APP_REDIRECT_URI as string, 
        // client_id: 'irmt-frontend',
        // client_id: 'rebricker-frontend',
        client_id: 'c3po-frontend',
        authority: process.env.REACT_APP_AUTHORITY as string,
        automaticSilentRenew: true,
        silent_redirect_uri: process.env.REACT_APP_REDIRECT_URI as string,
        post_logout_redirect_uri: process.env.REACT_APP_REDIRECT_URI as string,
    }));
                


    return (
        // <div className='h-[100vh] w-[100vw] flex p-4 bg-gray'>
        <div className='min-h-full w-full'>

            {/* <div className=''> */}
                <AuthProvider userManager={userManager} autoSignIn={true}>
                    <Router>
                        <SnackbarProvider>
                            <Routes>


                                {/* <Route path="/" element={<HeaderLayout />}>
                                    <Route index element={<Home/>}/> 
                                    <Route path='/orders' element={<OrderPage/>}/>
                                    <Route path='/createlabels' element={<CreateLabels/>}/>
                                    
                                    <Route path="*" element={<Home />} />
                                </Route> */}

                                
                                <Route path='/' element={<Home/>}/>
                                <Route path='/createlabels' element={<CreateLabels/>}/>
                                <Route path='/purchaseorders' element={<Orders/>}/>
                                <Route path='/purchaseorder/:orderId' element={<OrderDetail/>}/>
                                {/* <Route path='/article/:articleId' element={<ArticleDetail/>}/> */}


                                <Route path='/salesorders' element={<SalesOrders/>}/>
                                {/* <Route path='/salesorder/:orderId' element={<SalesWrapperDetail/>}/> */}
                                <Route path='/salesorder/:orderId' element={<SalesWrapDetail/>}/>
                                

                                <Route path="/warehouse/*" element={<WarehouseModule />} />

                            </Routes>
                        </SnackbarProvider>

                    </Router>
                </AuthProvider>
            {/* </div> */}
        </div>
    );
}

export default App;
